export default class ConfirmPhoneForm {
    constructor(formsGroup) {
        this.initForms = [];
        this.formsGroup = formsGroup;
        this.initialForms();
    }

    initialForms() {
        let $this = this;
        this.changeForms();
        $(this.formsGroup).find('form').each(function () {
            $this.formValidator($(this));
        });
    }

    /**
     *
     * @param $form
     * This function will be extend
     */
    formValidator($form) {
        //Validation & some actions
    }

    /**
     * Reset data & valid messages
     */
    resetValidate() {
        $(this.formsGroup).find('form').each(function() {
            $(this)[0].reset();
            $(this).find('.full').removeClass('full');
        });
        this.initForms.forEach(function (form) {
            form.resetForm();
        });
    }

    /**
     * Reset single form
     */
    resetThisForm($form) {
        if($form.length) {
            $form[0].reset();
            $form.find('.full').removeClass('full');
            $form.validate().resetForm();
            $form.find('.error-general').hide();
        }
    }

    /**
     * Repeat sms
     */
    timerSendSms($form) {
        let $timer = $form.find('.send_sms_again'),
            time = Number($timer.find('i').attr('data-time'));

        clearInterval(this.timerSms);
        $timer.find('i').html(time);
        $timer.find('a span').show();
        $timer.find('a').removeClass('active');

        this.timerSms = setInterval(function () {
            if(time > 0) {
                $timer.find('i').html(--time);
            } else {
                clearInterval(this.timerSms);
                $timer.find('a span').hide();
                $timer.find('a').addClass('active');
            }
        }, 1000);
    }

    /**
     *  Change forms
     */
    changeForms() {
        let $forms = $(this.formsGroup),
            $this = this;

        $forms.on('click', '.to_form:not(.disabled)', function (e) {
            e.preventDefault();
            let id = $(this).attr('data-id'),
                focusName = $(this).attr('data-focus');

            if(id) {
                if(!$(this).attr('data-reset')) {
                    $this.resetValidate();
                }
                if($(this).attr('data-single-reset')) {
                    $this.resetThisForm($(this).closest('form'));
                }

                let $thisWrap = $(this).closest('form');
                $thisWrap.animate({opacity: 0}, 200, function() {
                    $thisWrap.hide();

                    $(id).show();
                    $(id).animate({opacity: 1}, 200, function () {
                        //Focus on input
                        if(focusName) {
                            $(id).find('input[name='+ focusName +']').focus();
                        }
                    });
                });
            }

        })
    }

    /**
     *
     * @param form
     * @param error
     */
    showFormError(form, error) {
        let $error = form.find('.error-general');
        $error.text(error).show();
    }

    /**
     *
     * @param form
     */
    hideFormError(form) {
        let $error = $(form).find('.error-general');
        $error.hide().text('');
    }

    /**
     *
     * @param form
     * @param xhr
     * @returns {string}
     */
    ajaxErrorForm(form, xhr) {
        let error = {};
        if (xhr.status === 422) {
            let err = JSON.parse(xhr.responseText);
            $.each(err.errors, function (field, messages) {
                error[field] = messages[0];
            });
            form.showErrors(error);
        }
        return 'Error';
    }

    /**
     *
     * @param xhr
     * @returns {string}
     */
    ajaxErrorMsg (xhr) {
        if (xhr.status === 422) {
            let err = JSON.parse(xhr.responseText);
            let msg = '';
            $.each(err.errors, function (field, messages) {
                msg += messages.join('\n') + '\n';
            });
            return msg;
        }
        return 'Error';
    };

    ajaxErrorHandler(xhr) {
        alert(this.ajaxErrorMsg(xhr));
    }
}
